/**
 * 전화번호 하이픈 자동 포맷 (iOS `String.phone` 동일).
 * - 11자리: `010-1234-5678`
 * - 10자리: `010-123-4567`
 */
export const formatPhone = (input: string): string => {
  const digits = input.replace(/[^0-9]/g, '');
  if (digits.length < 4) {
    return digits;
  }
  if (digits.length < 7) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }
  if (digits.length < 11) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
};

/**
 * 휴대폰 번호 형식 검증 (iOS `validatePhoneNumber` 정규식 동일).
 */
export const validatePhoneNumber = (value: string): boolean =>
  /^01([0|1|6|7|8|9]?)-([0-9]{3,4})-([0-9]{4})$/.test(value);
